import { EventName } from '@lit/react';
import { BlocksSegmentedControl } from 'blocks-nextjs/blocks-web-components/components/segmented-control/segmented-control';
import { BlocksSegmentItemChange } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatSegmentedControl = createComponent({
  react: React,
  tagName: 'cat-segmented-control',
  elementClass: BlocksSegmentedControl,
  events: {
    onBlSegmentItemChange: 'bl-segment-item-change' as EventName<BlocksSegmentItemChange>
  }
});
